"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modalStylePropTypes = exports.ModalStyled = exports.Footer = exports.FixedHeightContentWrapper = exports.Box = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _Box = _interopRequireDefault(require("../Containers/Box"));
var _ButtonsContainer = _interopRequireDefault(require("../Containers/ButtonsContainer"));
var _mixins = require("../mixins");
var _helpers = require("../helpers");
var _base = require("../themes/_base");
var _excluded = ["className", "modalClassName", "overlayClassName", "automationHook"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var modalStylePropTypes = {
  /** Specify a width for the modal window - if this is bigger than the current window width, width will be limited to 100% */
  w: _propTypes["default"].string,
  /** DEPRECATED */
  width: _propTypes["default"].string,
  /** Specify a fixed height for the modal window */
  h: _propTypes["default"].string,
  /** DEPRECATED */
  height: _propTypes["default"].string,
  /** Specify a padding for the modal window. If none is provided, it pads with base space */
  p: _propTypes["default"].oneOf(_base.spaceTypes),
  /** Give a backgroundColor for the Modal Content */
  backgroundColor: _propTypes["default"].string,
  /** When you don't want the modal to be centered, you can position it relative to the top or bottom of the screen;
   * you can combine this with the offset prop, that will give it a different margin   */
  verticalPosition: _propTypes["default"].oneOf(["bottom", "top", "center"]),
  /** When positioning the modal vertically, you may wanna specify an offset from top/ bottom
   * which will add a margin top/bottom - so it can be any valid css string for margin
   * NOTE: this prop only works if verticalPosition is set to "top" or "bottom"
   */
  offset: _propTypes["default"].string
};
exports.modalStylePropTypes = modalStylePropTypes;
var ReactModalAdapter = function ReactModalAdapter(_ref) {
  var className = _ref.className,
    modalClassName = _ref.modalClassName,
    overlayClassName = _ref.overlayClassName,
    automationHook = _ref.automationHook,
    rest = _objectWithoutProperties(_ref, _excluded);
  var width = rest.width,
    height = rest.height;
  (0, _helpers.useDeprecate)({
    width: width,
    height: height
  }, "ModalStyles");
  return /*#__PURE__*/_react["default"].createElement(_reactModal["default"], _extends({
    className: modalClassName,
    overlayClassName: overlayClassName,
    portalClassName: className,
    data: {
      hook: (0, _automationHooks.getHook)(automationHook, "modal")
    }
  }, rest));
};
ReactModalAdapter.propTypes = {
  className: _propTypes["default"].string,
  /** Set by ModalStyled to "overlay". Is used for styling. */
  modalClassName: _propTypes["default"].string,
  /** Set by ModalStyled to "modal". Is used for styling. */
  overlayClassName: _propTypes["default"].string,
  /** Hook used for automation testing */
  automationHook: _propTypes["default"].string
};

/** Modal Styled is a wrapper around React Modal and sets styles for the overlay and the modal */
var ModalStyled = (0, _styledComponents["default"])(ReactModalAdapter).attrs(function (props) {
  var _props$h, _props$w;
  return {
    overlayClassName: "overlay",
    modalClassName: "modal",
    h: (_props$h = props.h) !== null && _props$h !== void 0 ? _props$h : props.height,
    w: (_props$w = props.w) !== null && _props$w !== void 0 ? _props$w : props.width
  };
}).withConfig({
  displayName: "ModalStyles__ModalStyled",
  componentId: "sc-ctryca-0"
})(["position:fixed;z-index:", ";.overlay{position:fixed;top:0;left:0;right:0;bottom:0;display:flex;justify-content:center;background:", ";align-items:center;max-height:100%;}.modal{overflow:hidden;width:", ";max-width:100%;max-height:calc(100% - 2 * ", ");overflow:auto;margin:", ";outline:0;border-radius:", ";", ";position:relative;box-shadow:", ";", ";", ";}", ";", ";"], function (props) {
  return props.theme.zIndex.modal;
}, function (props) {
  return (0, _helpers.getColor)(props, "overlayColor", "modalOverlay");
}, function (props) {
  return props.w || "48rem";
}, function (props) {
  return props.theme.spaces.m;
}, function (props) {
  return props.theme.spaces.base;
}, function (props) {
  return props.theme.borderRadius.m;
}, (0, _mixins.backgroundMixin)("backgroundPrimary"), function (props) {
  return props.theme.boxShadow.modal;
}, function (props) {
  return props.h && (0, _styledComponents.css)(["height:", ";overflow:hidden;"], props.h);
}, function (props) {
  return props.variant && props.variant === "alignBottom" && (0, _styledComponents.css)(["align-self:flex-end;"]);
}, function (props) {
  return props.verticalPosition && (props.verticalPosition === "bottom" || props.verticalPosition === "top") && (0, _styledComponents.css)([".overlay{align-items:", ";}", ""], props.verticalPosition === "bottom" ? "flex-end" : "flex-start", props.offset && (0, _styledComponents.css)([".modal{", ":", ";max-height:calc(100% - ", " - ", ");}"], "margin-".concat(props.verticalPosition), props.offset, props.theme.spaces.m, props.offset));
}, function (props) {
  return props.variant && props.variant === "tooltip" && (0, _styledComponents.css)([".overlay{background:transparent;}.modal{margin:0;box-shadow:", ";position:absolute;top:", ";left:", ";transform:translate( ", ",", " );width:auto;}"], props.theme.boxShadow.card, props.positionY || "50%", props.positionX || "50%", props.translateX || "10px", props.translateY || "10px");
});

/** This is a wrapper used around Modal content to make it scrollable, when the Modal has a fixed height */
exports.ModalStyled = ModalStyled;
var FixedHeightContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ModalStyles__FixedHeightContentWrapper",
  componentId: "sc-ctryca-1"
})(["height:100%;overflow:auto;-webkit-overflow-scrolling:touch;"]);
exports.FixedHeightContentWrapper = FixedHeightContentWrapper;
var modalBoxMixin = (0, _styledComponents.css)(["padding:", ";", ";"], function (props) {
  return props.theme.layouts.p;
}, _mixins.paddingMixin);
var Footer = (0, _styledComponents["default"])(_ButtonsContainer["default"]).withConfig({
  displayName: "ModalStyles__Footer",
  componentId: "sc-ctryca-2"
})(["position:sticky;bottom:0;background-color:", ";border-top:1px solid ", ";", ";"], function (props) {
  return props.theme.colors.backgroundPrimary;
}, function (props) {
  return props.theme.colors.border;
}, modalBoxMixin);
exports.Footer = Footer;
Footer.displayName = "Modal.Footer";
var Box = (0, _styledComponents["default"])(_Box["default"]).attrs(function (props) {
  return {
    d: "flex",
    direction: props.direction || "column"
  };
}).withConfig({
  displayName: "ModalStyles__Box",
  componentId: "sc-ctryca-3"
})(["", ";&:first-of-type{padding-right:calc( ", " + ", " );", ";}"], modalBoxMixin, function (props) {
  return props.theme.layouts.p;
}, function (props) {
  return props.theme.spaces.s;
}, _mixins.paddingMixin);
exports.Box = Box;
Box.displayName = "Modal.Box";